import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { useSearchParams } from "react-router-dom";
import { ReportService } from "../../../services/ReportService";
import PrintButton from "../../../components/buttons/PrintButton";

export default function ReportCancelamento() {
  const [searchParams] = useSearchParams();
  const selectedPeriod = searchParams.get("period");

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reportService = new ReportService();

  const periodParts = selectedPeriod ? selectedPeriod.split("-") : [];
  const [month, year] = periodParts.map(Number);

  const isValidPeriod =
    periodParts.length === 2 &&
    !isNaN(month) &&
    !isNaN(year) &&
    month >= 1 &&
    month <= 12;

  useEffect(() => {
    if (!isValidPeriod) return;

    setLoading(true);
    setError("");

    reportService
      .getRelatorioCancelamentos(selectedPeriod)
      .then((data) => setReportData(data || []))
      .catch(() => setError("Erro ao carregar o relatório."))
      .finally(() => setLoading(false));
  }, [selectedPeriod]);

  const formatDateTime = (date, startDate, endDate) => {
    try {
      const start = DateTime.fromISO(startDate, { zone: "UTC" })
        .setZone("America/Sao_Paulo")
        .setLocale("pt-BR")
        .toFormat("ccc dd/MM/yyyy HH:mm")
        .toUpperCase()
        .replace(/\./, "");

      const end = DateTime.fromISO(endDate, { zone: "UTC" })
        .setZone("America/Sao_Paulo")
        .toFormat("HH:mm");

      return `${start} ÀS ${end}`;
    } catch (error) {
      console.error("Error formatting datetime:", error);
      return "Data inválida";
    }
  };

  const periodDate = DateTime.fromObject({ year, month }, { zone: "America/Sao_Paulo" });

  const yearAndMonth = periodDate.toFormat("yyyy-MM");

  return (
    <div>
      <div className="container mt-4">
        <PrintButton
          fileName={`${yearAndMonth} - RELATÓRIO DE CANCELAMENTOS`}
        />

        <div className="row">
          <div className="col-3">
            <img src="/logo.png" alt="Logo" width="120" />
          </div>

          <div className="col-9 text-center">
            <h3 className="fw-bold">GAMA - GUARDA MUNICIPAL DE AMERICANA</h3>
            <h3>SISTEMA DE DIÁRIA ADICIONAL POR ESCALA EXTRAORDINÁRIA</h3>
            <h3>RELATÓRIO DE CANCELAMENTOS</h3>
          </div>
        </div>

        {error && <div className="text-danger mt-3">{error}</div>}
        {loading && <p>Carregando...</p>}

        {reportData.length > 0 && (
          <div className="mt-4">
            {reportData.map((user) => (
              <div key={user.username} className="mb-5">
                <h4>
                  {user.name?.toUpperCase()} - MATRÍCULA: {user.username}
                </h4>
                <table className="table table-bordered custom-table">
                  <thead>
                    {/* <tr className="bg-secondary text-white">
                      <th className="school-header" colSpan="5">
                        {user.schoolName?.toUpperCase()}
                      </th>
                    </tr> */}
                    <tr>
                      <th>DIA HORA</th>
                      <th>UNID. ESCOLAR</th>
                      <th>STATUS</th>
                      <th>MOTIVO / JUSTIFICATIVA</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user.reservations.map((res, index) => (
                      <tr key={index}>
                        <td>
                          {formatDateTime(res.date, res.startDate, res.endDate)}
                        </td>
                        <td>{user.schoolName}</td>
                        <td className="fw-bold">CANCELADO</td>
                        <td>{res.note || "Sem justificativa"}</td>
                      </tr>
                    ))}
                    <tr className="bg-secondary text-white">
                      <td className="school-header" colSpan="3">
                        TOTAL
                      </td>
                      <td className="school-header">
                        {user?.reservations?.length} OCORRÊNCIAS
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
